import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

import type { CommonModalProps } from '@wecasa/common/src/types/components';
import colors from '@wecasa/common/src/utils/colors';

import { translate } from '@wecasa/i18n';

import { minWidth } from '../../styles/mixins';
import IconButton from '../button/icon-button';
import AccessibleModal from './accessible-modal';
import { slideDown, slideUp } from './common';
import ModalContainerWithBackdrop, { MODAL_ANIMATION_DURATION } from './modal-container-with-backdrop';

const t = translate('base');

type StyledModalProps = { $isOpen: boolean };

const StyledModal = styled(AccessibleModal)<StyledModalProps>`
  width: 100%;
  height: 100%;
  background-color: ${colors.white100};
  overflow-y: auto;
  animation: ${({ $isOpen }: StyledModalProps) => ($isOpen ? slideUp : slideDown)} ${MODAL_ANIMATION_DURATION}ms ease
    forwards;

  ${minWidth.md`
    max-width: 650px;
    margin: auto;
  `}
`;

const CloseIcon = styled(IconButton)`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1;
`;

type FullHeightCenteredModalProps = PropsWithChildren<Omit<CommonModalProps, 'onClose'>> & {
  onClose?: () => void;
};

const FullHeightCenteredModal = ({ isOpen, onClose, children }: FullHeightCenteredModalProps) => (
  <ModalContainerWithBackdrop isOpen={isOpen} onClose={onClose} hasBackdropBlur>
    <StyledModal $isOpen={isOpen}>
      {!!onClose && (
        <CloseIcon type='whitedark' onPress={onClose} size={30} iconSize={13} iconName='close' label={t('.close')} />
      )}
      {children}
    </StyledModal>
  </ModalContainerWithBackdrop>
);

export default FullHeightCenteredModal;
